/* Simply Bearings UK — <ax-banner-videos> : lecture maîtrisée des vidéos du
   hero image-banner. Les <video> sont rendues en preload="none" sans autoplay
   natif : on ne télécharge/joue que la vidéo visible (breakpoint courant +
   viewport), pause hors écran. Respecte prefers-reduced-motion (poster
   statique). Web Component : le lifecycle DOM gère les re-renders de
   l'éditeur de thème (observer/listeners nettoyés au disconnect). */
if (!customElements.get('ax-banner-videos')) {
  customElements.define(
    'ax-banner-videos',
    class AxBannerVideos extends HTMLElement {
      static REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
      static MOBILE_BREAKPOINT = window.matchMedia('(max-width: 749px)');

      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];
        if (!this.videos.length) return;

        this.intersecting = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            this.intersecting = entries[entries.length - 1].isIntersecting;
            this.refresh();
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this);
        AxBannerVideos.MOBILE_BREAKPOINT.addEventListener('change', this.refresh);
        AxBannerVideos.REDUCED_MOTION.addEventListener('change', this.refresh);
      }

      disconnectedCallback() {
        if (!this.observer) return;
        this.observer.disconnect();
        AxBannerVideos.MOBILE_BREAKPOINT.removeEventListener('change', this.refresh);
        AxBannerVideos.REDUCED_MOTION.removeEventListener('change', this.refresh);
        this.videos.forEach((video) => video.pause());
      }

      refresh = () => {
        this.videos.forEach((video) => {
          const visible = this.intersecting && video.offsetParent !== null;
          if (visible && !AxBannerVideos.REDUCED_MOTION.matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };
    }
  );
}
